import { analyticsClient } from 'src/shared/services/analytics';

interface TrackAssessment {
    assessmentName: string;
    assessmentFlowUuid: string;
    answer: number | string | string[] | null;
}

export const trackAssessment = ({
    assessmentName,
    assessmentFlowUuid,
    answer,
}: TrackAssessment) => {
    const eventName = `Assessment ${assessmentName}`;
    analyticsClient.trackClick(eventName, {
        event_name: eventName,
        flow: 'Assessment',
        assessmentFlowUuid,
        // answer could be a string[] when answers are multiselected
        answer: answer === null ? 'no answer recorded' : JSON.stringify(answer),
    });
};
